import { Button } from '@/components/ui/button';
import { useLocation } from 'react-router-dom';
import gibletLogoGreen from '@/assets/giblet-logo-green.png';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface GibletChatButtonProps {
  onClick: () => void;
}

export const GibletChatButton = ({ onClick }: GibletChatButtonProps) => {
  const location = useLocation();
  const variant = getGibletVariant(location.pathname);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="icon"
          onClick={onClick}
          className="h-10 w-10 rounded-full p-0 overflow-hidden"
          aria-label={`Ask ${variant}`}
        >
          <img 
            src={gibletLogoGreen} 
            alt="Giblet" 
            className="h-full w-full object-contain"
            style={{ imageRendering: 'crisp-edges' }}
          />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Ask {variant}</p>
      </TooltipContent>
    </Tooltip>
  );
};

const getGibletVariant = (pathname: string): string => {
  if (pathname.includes('usa-channel')) return 'Giblet U.S.';
  if (pathname.includes('curt') || pathname.includes('call-for-solutions')) return 'Giblet Construct';
  if (pathname.includes('oil-gas')) return 'Giblet Oil & Gas';
  if (pathname.includes('gsa') || pathname.includes('dept-education') || pathname.includes('noaa')) return 'Giblet Fed';
  return 'Giblet';
};
